module.exports = __webpack_public_path__ + "static/media/indent-increase.582caa53.svg";